"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginavatars = exports.avatars = void 0;
exports.getAvatars = getAvatars;
exports.getLoginAvatars = getLoginAvatars;
exports.getAvatar = getAvatar;
exports.getRandomLoginAvatar = getRandomLoginAvatar;
exports.getRandomAvatar = getRandomAvatar;
exports.getAvatarUrl = getAvatarUrl;
exports.getRandomAvatarUrl = getRandomAvatarUrl;
exports.avatars = Array(57)
    .fill(0)
    .map(function (_, i) { return "Grano_SokoPro_avatar_".concat(i); })
    .reverse();
exports.loginavatars = [
    56, 55, 54, 53, 52, 51, 50, 49, 48, 47, 46, 45, 44, 43, 42, 41, 40, 39, 38,
    37, 36, 35, 34, 33, 31, 28, 22, 21, 15, 14, 13, 7, 6, 5, 4, 3, 2
];
function getAvatars() {
    return exports.avatars;
}
function getLoginAvatars() {
    return exports.loginavatars;
}
function getAvatar(id) {
    var safeId;
    if (!id) {
        safeId = 0;
    }
    else {
        safeId = Math.floor(id);
        safeId = Math.max(0, safeId);
        safeId = Math.min(exports.avatars.length - 1, safeId);
    }
    return exports.avatars[safeId];
}
function getRandomLoginAvatar(id) {
    var safeId;
    if (!id) {
        safeId = 0;
    }
    else {
        safeId = Math.floor(id);
        safeId = Math.max(0, safeId);
        safeId = Math.min(exports.avatars.length - 1, safeId);
    }
    return exports.loginavatars[safeId];
}
function getRandomAvatar() {
    return exports.avatars[Math.floor(Math.random() * exports.avatars.length)];
}
function getAvatarUrl(avatar) {
    if (avatar === void 0) { avatar = getAvatar(0); }
    return "/assets/avatars/".concat(avatar, ".svg");
}
function getRandomAvatarUrl(avatar) {
    if (avatar === void 0) { avatar = getRandomLoginAvatar(Math.floor(Math.random() * exports.loginavatars.length)); }
    return "/assets/avatars/".concat(exports.avatars[avatar], ".svg");
}
